import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: 'Система мероприятий JDYun', // Заголовок сайта
  system_demo: 'Демо системы',
  confirm: 'Подтвердить',
  // Отмена
  cancel: 'Отмена',
  // Показать
  show: 'Показать',
  // Скрыть
  hide: 'Скрыть',
  // Включить
  open: 'Включить',
  // Выключить
  close: 'Выключить',
  // Сохранить
  save: 'Сохранить',
  // Редактировать
  edit: 'Редактировать',
  // Удалить
  delete: 'Удалить',
  // Добавить
  add: 'Добавить',
  // Поиск
  search: 'Поиск',
  // Запрос
  query: 'Запрос',
  // Сбросить
  reset: 'Сбросить',
  // Отправить
  submit: 'Отправить',
  // Загрузить
  upload: 'Загрузить',
  // Скачать
  download: 'Скачать',
  // Экспорт
  export: 'Экспорт',
  // Импорт
  import: 'Импорт',

  started: 'Начато',
  ended: 'Завершено',
  // Следующий шаг
  next: 'Далее',
  // Предыдущий шаг
  prev: 'Назад',
  // Опубликовать
  publish: 'Опубликовать',
  // Пожалуйста, введите
  input: 'Пожалуйста, введите {text}',
  // Пожалуйста, выберите
  select: 'Пожалуйста, выберите {text}',
  total: 'Всего {total}',
  price: '{price} RMB',
  required: '{text} обязательно',
  selected: 'Выбрано {total} {text}',
  // Создать
  create: 'Создать',
  // Бесплатно
  free: 'Бесплатно',
  // Платно
  charge: 'Платно',
  // По умолчанию
  default: 'По умолчанию',
  // Пользовательский
  custom: 'Пользовательский',
  // Максимум
  max: 'Максимум',
  // Минимум
  min: 'Минимум',
  // Процент
  percent: 'Процент',
  // Онлайн
  online: 'Онлайн',
  // Офлайн
  offline: 'Офлайн',
  name: 'Название',
  // Примечание
  remark: 'Примечание',
  // Подсказка
  tips: 'Подсказка',
  // Верхняя навигация
  header: {
    logout: 'Выйти',
    binding: 'Привязать аккаунт',
    mobile: 'Мобильный клиент продавца',
    register: 'Мобильный клиент',
    tips: 'Мероприятие {name}',
    qrcodeText: 'QR-код H5 {name}',
    qrcodeMiniText: 'Код мини-приложения {name}',
    qrcode: 'Нажмите для скачивания QR-кода',
    qrcodeMini: 'Нажмите для скачивания кода мини-приложения'
  },
  home: {
    title: 'Добро пожаловать в платформу управления мероприятиями Jindouyun',
    sub_title: 'Публикуйте здесь самые полные и подробные мероприятия и конференции',
    desc: 'Начните свой путь в организации мероприятий с управления мероприятиями',
    create: 'Быстро создать мероприятие'
  },
  user: {
    title: 'Основная информация об аккаунте',
    logo: 'Логотип бренда',
    update: 'Обновить',
    name: 'Название компании или организации',
    short_name: 'Бренд в верхнем левом меню',
    enable: 'Включить персонализированный вход',
    web_tips: 'URL персонализированного входа',
    copy: 'Копировать URL',
    login: 'Название бренда на странице входа',
    login_title: 'Название системы на странице входа'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // Локализация кодов состояния
  // Успешное выполнение операции
  // CODE_SUCCESS: 2000,
  2000: 'Операция выполнена успешно',
  // Ошибка возврата
  // CODE_ERROR: 5000,
  5000: 'Ошибка сетевого запроса, проверьте сеть',
  // Ошибка параметров
  // CODE_ERROR_PARAMS: 5001,
  5001: 'Ошибка параметров запроса',
  // Ошибка регистрации URL
  // CODE_ERROR_URL_REG_FAILURE: 5002,
  5002: 'Ошибка регистрации URL',
  // Ошибка параметров
  // CODE_ERROR_NO_PARAM: 5003,
  5003: 'Ошибка параметров',
  // Ошибка прав доступа
  // CODE_ERROR_PERSSION_ERROR: 5004,
  5004: 'Ошибка прав доступа',
  // Ошибка проверки JWT
  // CODE_JWT_ERROR: 5100,
  5100: 'Ошибка проверки JWT',
  // Ошибка входа
  // CODE_JWT_LOGIN_FAILURE: 5101,
  5101: 'Ошибка входа',
  // Недействительный JWT Token
  // CODE_JWT_TOKEN_INVALID: 5102,
  5102: 'Недействительный JWT',
  // Нет пользователей
  // CODE_JWT_NO_USER: 5103,
  5103: 'Пользователь не существует',
  //
  // CODE_PARAMS_TYPE_ERROR_SIZE = 5401
  5401: 'Ошибка параметра size',
  //
  // CODE_PARAMS_TYPE_ERROR_PAGE = 5402
  5402: 'Ошибка параметра page',
  //
  // CODE_PARAMS_TYPE_ERROR_QUERY = 5403
  5403: 'Ошибка ключевого слова запроса'
}



// WEBPACK FOOTER //
// ./src/langs/ru/index.js